import React, { useEffect } from "react";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import PaginatedView from "../../../components/UI/PaginatedView/PaginatedView";
import { funcionalidades } from "../../../context/AuthContext";
import { apiRoutes } from "../../../hooks/apiClient";

const columns = [
  {
    name: "Sigla",
    selector: "sigla",
    maxWidth: "7%",
    center: true,
    sortable: true,
  },
  {
    name: "Nome",
    selector: "nome",
    sortable: true,
  },
  {
    name: "Situação",
    selector: "status",
    maxWidth: "10%",
    sortable: true,
    center: true,
    cell: (row) => (row.status === "S" ? "Ativo" : "Inativo"),
  },
];

const validationSchema = Yup.object().shape({
  sqTipoParteServico: Yup.string().default(""),
  nome: Yup.string().default(""),
  sigla: Yup.string().default(""),
  status: Yup.string().default(""),
});

const initialValues = {};
validationSchema._nodes.forEach((key) => {
  initialValues[key] = "";
});

const ConsultaTipoParteServico = ({ history, match }) => {
  const { advancedSearchParameters } = useSelector((state) => state.advancedSearch);

  const formik = useFormik({ initialValues, validationSchema });

  const { setValues } = formik;

  useEffect(() => {
    if (Object.keys(advancedSearchParameters).length !== 0) {
      setValues({ ...advancedSearchParameters });
    }
  }, [setValues, advancedSearchParameters]);

  return (
    <PaginatedView
      title="Tipo de Parte de Serviço"
      keyField="sqTipoParteServico"
      descriptionField="nome"
      defaultSearch
      defaultSearchPlaceholder="Digite o Nome"
      queryService={apiRoutes.fiscalizacao.parametrizacao.consultaTipoParteServico}
      deleteService={apiRoutes.fiscalizacao.parametrizacao.excluiTipoParteServico}
      editRoute={`${match.url}/form`}
      columns={columns}
      permissionDelete={funcionalidades.tipoParteServico.deletar}
      permissionInsert={funcionalidades.tipoParteServico.inserir}
      history={history}
      reduxKey="tipoParteServico"
    />
  );
};

export default ConsultaTipoParteServico;
